module.exports = __webpack_public_path__ + "img/internet-dokon.0b0ab996.png";